import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { ZolaFileResponseType } from 'actions/types/UploadcareActions';
import { updatePageSilently } from 'actions/website/PageActions';
import ImageUploadV2 from 'components/common/ImageUploadV2/ImageUploadV2';
import { UploadCareTabTypes } from '@zola-helpers/client/dist/es/uploadcare/constants';
import { getPageHome } from 'selectors/website/pageSelectors';
import type { WCmsPageView, UpdateCmsPageRequest } from '@zola/svc-web-api-ts-client';
import { updatePreview } from 'actions/website/WebsitePreviewActions';
import sharedStyles from '../../../EditPageCommon/editPageSharedStyles.module.less';

type HomeImageUploadProps = {
  imageKey: 'header' | 'footer';
  className?: string;
};

const HomeImageUpload: React.FC<HomeImageUploadProps> = ({ imageKey, className }) => {
  const dispatch = useDispatch();
  const page: WCmsPageView = useSelector(getPageHome);
  const imageUrlKey: 'header_image_url' | 'footer_image_url' = `${imageKey}_image_url`;
  const imageUrl = page[imageUrlKey];

  const savePhoto = (zolaFile?: ZolaFileResponseType) => {
    const payload: Omit<UpdateCmsPageRequest, 'wedding_account_id'> = {
      ...page,
      id: page.id || 0,
      hidden: page.hidden || false,
      [imageUrlKey]: zolaFile?.cloudfront_url,
      [`${imageKey}_image_id`]: zolaFile?.uuid,
    };
    dispatch(updatePageSilently(payload));
  };

  useEffect(() => {
    dispatch(updatePreview({ [imageUrlKey]: imageUrl }));
  }, [imageUrl]);

  return (
    <div className={className}>
      <label className={sharedStyles.label}>
        {imageKey === 'header' ? 'Main' : 'Bottom'} Image{' '}
        <span className={sharedStyles.optionalLabel}>(Optional)</span>
      </label>
      <ImageUploadV2
        imageUrl={imageUrl}
        onUploadComplete={savePhoto}
        onClearImage={() => savePhoto()}
        maxSize={5}
        cropRatio="12:7"
        minHeight={700}
        analyticsLocation="WEBSITE"
        analyticsProduct="WEBSITE"
        tabs={[
          UploadCareTabTypes.FILE,
          UploadCareTabTypes.DROPBOX,
          UploadCareTabTypes.GOOGLE_PHOTOS,
          UploadCareTabTypes.ONE_DRIVE,
          UploadCareTabTypes.FACEBOOK,
          UploadCareTabTypes.INSTAGRAM,
        ]}
      />
    </div>
  );
};

export default HomeImageUpload;
